import { Eka01LessonsBox, Eka02LessonsBox, EkaTeaserBox } from "./utils"
import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"

import { EmailkursSignup } from "components/page-components/Signup-Forms"

export const EmailCoursesSignupModule = () => {
  const { eka01Thumbnail, eka02Thumbnail } = useStaticQuery(graphql`
    {
      eka01Thumbnail: file(name: { eq: "emailskurs-01-anmeldung-thumbnail" }) {
        childImageSharp {
          gatsbyImageData(
            formats: [AUTO, AVIF]
            width: 412
            layout: CONSTRAINED
            placeholder: BLURRED
          )
        }
      }
      eka02Thumbnail: file(name: { eq: "emailskurs-02-anmeldung-thumbnail" }) {
        childImageSharp {
          gatsbyImageData(
            formats: [AUTO, AVIF]
            width: 412
            layout: CONSTRAINED
            placeholder: BLURRED
          )
        }
      }
    }
  `)
  const [auftragnehmerSelected, setAuftragnehmerSelected] = useState(true)
  const [lessonsActive, setLessonsActive] = useState(false)
  const toggleLessons = () => setLessonsActive(!lessonsActive)

  const selectAuftragnehmer = (e) => {
    e.preventDefault()
    setAuftragnehmerSelected(true)
  }

  const selectAuftraggeber = (e) => {
    e.preventDefault()
    setAuftragnehmerSelected(false)
  }
  return (
    <div
      data-nosnippet
      className="columns is-centered"
      id="emailkurs-signup-modul"
    >
      <div className="column is-7-widescreen is-12-mobile">
        <div className="tabs ad-landingpage-tabs is-fullwidth is-centered mb-2">
          <ul>
            <li className={auftragnehmerSelected ? "is-active" : ""}>
              <a
                className="has-text-mitternachtsblau"
                onClick={selectAuftragnehmer}
                onKeyPress={() => {}}
                aria-label="select auftraggeber"
                href="# "
              >
                Kurs für Auftragnehmer
              </a>
            </li>
            <li className={!auftragnehmerSelected ? "is-active" : ""}>
              <a
                className="has-text-mitternachtsblau"
                onKeyPress={() => {}}
                aria-label="select leistungsarten"
                href="# "
                onClick={selectAuftraggeber}
              >
                Kurs für Auftraggeber
              </a>
            </li>
          </ul>
        </div>
        <div
          className={`has-background-${
            auftragnehmerSelected
              ? "auftragsvolumendunkelgruen"
              : "budgetierungshellblau"
          }`}
          style={{ transition: "all .4s ease" }}
        >
          <div className="columns is-vcentered">
            <div className="column is-8-widescreen is-12-mobile has-text-white">
              <div
                className="section pb-0 px-0-mobile"
                style={{ display: "grid" }}
              >
                <div
                  className=""
                  style={{
                    transition: "all .2s ease",
                    opacity: auftragnehmerSelected ? 1 : 0,
                    gridArea: "1/1",
                  }}
                >
                  <p className="has-text-weight-bold">
                    Kostenfreier E-Mail-Kurs:
                  </p>

                  <p className="title is-3 is-size-4-mobile has-text-white">
                    Einstieg ins Vergaberecht
                  </p>
                  <p className="has-text-weight-bold mb-5">
                    Lernen Sie alles wichtige für die Teilnahme an
                    elektronischen Vergaben für Ihren nächsten Auftrag.
                  </p>
                  <ul>
                    <li>
                      <b className="mr-2">5</b> Lektionen direkt in Ihr Postfach
                    </li>

                    <li>
                      <b className="mr-2">2</b> Quizze: Testen Sie Ihr Wissen!
                    </li>

                    <li>
                      <b className="mr-2">1</b> Überraschung
                    </li>
                  </ul>
                </div>

                <div
                  className=""
                  style={{
                    transition: "all .3s ease",
                    opacity: !auftragnehmerSelected ? 1 : 0,
                    gridArea: "1/1",
                  }}
                >
                  <p className="has-text-weight-bold">
                    Auftraggeber aufgepasst:
                  </p>
                  <p className="title is-3 is-size-4-mobile has-text-white">
                    Der kostenlose E-Mail-Kurs für Sie!
                  </p>
                  <p className="has-text-weight-bold mb-5">
                    Erhalten Sie wertvolle Tipps, die Ihre elektronische Vergabe
                    zum Erfolg machen!
                  </p>
                  <ul>
                    <li>
                      <b className="mr-2">4</b> Lektionen direkt in Ihr Postfach
                    </li>

                    <li>
                      <b className="mr-2">1</b> Quiz: Testen Sie Ihr Wissen!
                    </li>
                  </ul>
                </div>
                <EmailkursSignup
                  ressort="ausschreibungsdienste"
                  course={auftragnehmerSelected ? "eka1" : "ekag1"}
                />
              </div>
            </div>
            <div
              className="column is-7-widescreen my-4"
              style={{ display: "grid", position: "relative" }}
            >
              <EkaTeaserBox
                {...{
                  auftragnehmerSelected,
                  toggleLessons,
                  thumbnail: eka01Thumbnail,
                  lessonsActive,
                  reverseBoolean: false,
                  lessonOneTitle: "Öffentliche Ausschreibungen",
                }}
              />

              <EkaTeaserBox
                {...{
                  auftragnehmerSelected,
                  toggleLessons,
                  thumbnail: eka02Thumbnail,
                  lessonsActive,
                  reverseBoolean: true,
                  lessonOneTitle: "Ablauf eines Vergabeverfahrens",
                }}
              />
              <div style={{ display: "grid" }}>
                {auftragnehmerSelected ? (
                  <Eka01LessonsBox {...{ lessonsActive, toggleLessons }} />
                ) : (
                  <Eka02LessonsBox {...{ lessonsActive, toggleLessons }} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="column is-1"></div>
    </div>
  )
}
